import React, { useState, useEffect } from 'react';
import CartItemCSS from './CartItem.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ProductSearch from '../../ProductSearch';
import ClearButton from './ClearButton';
import { NumberInputField } from './material-ui/NumberInputField';
import { useMediaQuery, useTheme } from '@mui/material';

// const ComboBox = ({ results = [] })  => {
//   return (
//     <Autocomplete
//       disablePortal
//       id="combo-box-demo"
//       options={results}
//       sx={{ width: 300 }}
//       renderInput={(params) => <TextField {...params} label="Product" />}
//     />
//   );
// }

const CartItem = ({ product, quantity, onAddSelectedProduct, onRemoveFromSelectedProducts, onPaymentMethodChange, onQuantityChange }) => {
  const [paymentMethod, setPaymentMethod] = useState("cash");

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // const [quantity, setQuantity] = useState(1);
  //
  const handleQuantityChange = (event, value) => {
    console.log("Event: ", event);
    console.log("Value: ", value);

    // const newQuantity = Math.max(parseInt(value, 10) || 1, 1);
    onQuantityChange(product, event.target.value)
    // setQuantity(newQuantity);
    //
    // // Save quantity to local storage with a unique key for each product
    // localStorage.setItem(`quantity-${product.thumbnailUrl}`, newQuantity.toString());
  };

  const handlePaymentMethodChange = (event) => {
    const newPaymentMethod = event.target.value;
    setPaymentMethod(newPaymentMethod);

    localStorage.setItem(`payment-method-${product.airtableRecordId || product.thumbnailUrl}`, newPaymentMethod)
    onPaymentMethodChange(product, newPaymentMethod);
  }

  const removeFromSelectedProducts = (product) => {
    onRemoveFromSelectedProducts(product);
  };

  const handleSelect = (product) => {
    onAddSelectedProduct(product)
  }

  const calculateTotalPrice = (product, paymentMethod) => {
    var price = 0;
    if (paymentMethod === 'store-credit') {
      // price = product.newAveragePrice * (104 / 91) * quantity;
      price = product.storeCreditPrice * quantity;
    } else if (paymentMethod === 'cash') {
      // price = product.newAveragePrice * quantity;
      price = product.cashPrice * quantity;
    }
    // return Math.round(price * 100) / 100;
    return price;
  };

  if (product == undefined) {
    return (
      <li key="first-item" className="cart-item">
          <div className="cart-item-info">
            <ProductSearch onSelect={handleSelect} />
          </div>
      </li>
    );
  }

    // return (
    //
    //     <li key={product.product} className="cart-item">
    //       <div className="cart-item-info">
    //
    //       </div>
    //     </li>
    // )


    // <div className="cart-item-metadata">
    //   <label htmlFor={`store-credit-price-${product.product}`}>Store Credit: ${calculateTotalPrice(product, "store-credit")}</label>
    //   <label htmlFor={`cash-price-${product.product}`}>Store Credit: ${calculateTotalPrice(product, "cash")}</label>
    // </div>


  const handleDeleteButtonClick = () => {
    onRemoveFromSelectedProducts(product);
  }

  return (
    <li key={product.product} className="cart-item">
      <div className="cart-item-info">
        <div className="cart-item-image-wrapper">
          <img src={product.thumbnailUrl} alt={product.product} />
        </div>
        <div className="cart-item-metadata">
        <p>{product.itemName || product.product}{product.modelName ? <><br/><small>{product.modelName}</small></> : null}</p>
        <div className="price-quantity">
          <div className="quantity-container">
            <label htmlFor={`quantity-${product.product}`}>{isSmallScreen ? 'Qty: ': 'Quantity: '}</label>
            <NumberInputField
              id={`quantity-${product.airtableRecordId || product.thumbnailUrl}`}
              name={`quantity-${product.airtableRecordId || product.thumbnailUrl}`}
              value={quantity}
              min={1}
              onChange={handleQuantityChange}
            />
          </div>
          <div className="payment-method-container">
          { product.requiresReview ? (
  <b className="price-review-note" style={{ color: 'white' }}>
    Please email <a href="mailto:info@bucketlistguitars.com" style={{ color: 'rgb(0, 198, 255)' }}>info@bucketlistguitars.com</a> for price.
  </b>
) : (<FormControl>
              <RadioGroup
                row
                name="controlled-radio-buttons-group"
                value={paymentMethod}
                onChange={handlePaymentMethodChange}
              >
                <FormControlLabel value="store-credit" control={<Radio />} label={<div>Store Credit <b style={{ paddingLeft: 8 }}>${calculateTotalPrice(product, "store-credit")}</b> </div>} />
                <FormControlLabel value="cash" control={<Radio />} label={<div>Cash <b style={{ paddingLeft: 16 }}>${calculateTotalPrice(product, "cash")}</b> </div>} />
              </RadioGroup>
            </FormControl>)
          }
          </div>
        </div>
      </div>
        <div>
          <ClearButton onClick={handleDeleteButtonClick}/>
        </div>
      </div>
    </li>
  );
};



export default CartItem;
